import React from "react";
import { Alert, Card, CardContent, Grid2, Stack, TextField, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import DailyMatchLimitsSection from "./DailyMatchLimitsSection";

function SchedulingConfigSection({
  config,
  handleConfigChange,
  handleNullableConfigChange,
  intl,
  windows,
  handleDailyRulesChange,
}) {
  return (
    <Stack spacing={2}>
      <Card variant="outlined">
        <CardContent>
          <SectionHeading
            icon={<AccessTimeIcon color="primary" />}
            number="1"
            title={intl.formatMessage({ id: "scheduling.rules.timeTitle" })}
            description={intl.formatMessage({ id: "scheduling.rules.timeHelp" })}
          />

          <Alert severity="info" sx={{ my: 2 }}>
            {intl.formatMessage({ id: "scheduling.equity.help" })}
          </Alert>
          <Grid2 container spacing={2} sx={{ mt: 3 }}>
            <TimeField
              label={intl.formatMessage({ id: "Duración partido (min)" })}
              value={config.default_match_duration_minutes}
              onChange={handleConfigChange("default_match_duration_minutes")}
              min={15}
              max={300}
            />
            <TimeField
              label={intl.formatMessage({ id: "Duración semifinal (min)" })}
              value={config.semifinal_match_duration_minutes}
              onChange={handleConfigChange("semifinal_match_duration_minutes")}
              min={15}
              max={300}
            />
            <TimeField
              label={intl.formatMessage({ id: "Duración final (min)" })}
              value={config.final_match_duration_minutes}
              onChange={handleConfigChange("final_match_duration_minutes")}
              min={15}
              max={300}
            />
            <TimeField
              label={intl.formatMessage({ id: "Descanso mínimo (min)" })}
              value={config.min_rest_minutes}
              onChange={handleConfigChange("min_rest_minutes")}
              min={0}
              max={1440}
            />
            <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
              <TextField
                fullWidth
                size="small"
                type="number"
                label={intl.formatMessage({ id: "scheduling.rest.semifinalFinal" })}
                value={config.semifinal_final_rest_minutes ?? ""}
                onChange={handleNullableConfigChange("semifinal_final_rest_minutes")}
                inputProps={{ min: 0, max: 1440 }}
                helperText={intl.formatMessage({ id: "scheduling.rest.semifinalFinalHelp" })}
              />
            </Grid2>
            <TimeField
              label={intl.formatMessage({ id: "Buffer entre partidos (min)" })}
              value={config.buffer_between_matches_minutes}
              onChange={handleConfigChange("buffer_between_matches_minutes")}
              min={0}
              max={120}
            />
            <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
              <TextField
                fullWidth
                type="number"
                size="small"
                label={intl.formatMessage({ id: "Máx. partidos por participante/día" })}
                value={config.max_matches_per_day_per_player ?? ""}
                onChange={handleNullableConfigChange("max_matches_per_day_per_player")}
                inputProps={{ min: 1, max: 20 }}
                helperText={intl.formatMessage({ id: "scheduling.daily.generalHelp" })}
              />
            </Grid2>
          </Grid2>
        </CardContent>
      </Card>

      <Card variant="outlined">
        <CardContent>
          <SectionHeading
            icon={<CalendarMonthIcon color="primary" />}
            number="2"
            title={intl.formatMessage({ id: "scheduling.rules.dailyTitle" })}
            description={intl.formatMessage({ id: "scheduling.rules.dailyHelp" })}
          />
          <DailyMatchLimitsSection config={config} windows={windows} onChange={handleDailyRulesChange} intl={intl} />
        </CardContent>
      </Card>
    </Stack>
  );
}

function TimeField({ label, value, onChange, min, max }) {
  return (
    <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
      <TextField
        fullWidth
        type="number"
        size="small"
        label={label}
        value={value}
        onChange={onChange}
        inputProps={{ min, max }}
      />
    </Grid2>
  );
}

function SectionHeading({ icon, number, title, description }) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="flex-start" sx={{ mb: 2 }}>
      {icon}
      <div>
        <Typography variant="h6">
          {number}. {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          {description}
        </Typography>
      </div>
    </Stack>
  );
}

export default SchedulingConfigSection;
